import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home/Home';
import ProjectDetails from './Pages/Home/ProjectDetails';
import Footer from './Pages/Shared/Footer';
import Navbar from './Pages/Shared/Navbar';

function App() {
  return (
    <div >
     <Navbar></Navbar>

     <Routes>
       <Route path='/' element={<Home></Home>}></Route>
       <Route path='projects/:projectId' element={<ProjectDetails></ProjectDetails>}></Route>
     </Routes>

     <Footer></Footer>
    </div>
  );
}

export default App;
